import { getQueryParams } from "src/standard/services/getQueryParams";
import { querystring } from "src/standard/ts/querystring";

export function removeQueryParams<T extends unknown>(
  remove: Extract<keyof T, string> | Extract<keyof T, string>[],
) {
  const queryParams = getQueryParams();

  // We want to iterate over the remove object and remove the keys from the queryParams object
  const newQueryParams = { ...queryParams };
  if (typeof remove === "string") {
    if (remove in newQueryParams) {
      delete newQueryParams[remove];
    }
  } else {
    for (const key of remove) {
      if (key in newQueryParams) {
        delete newQueryParams[key];
      }
    }
  }

  // then push the state (so the URL updates)
  const queryString = querystring(newQueryParams);
  const hash = window.location.hash;
  const url = `${window.location.pathname}${queryString ? `?${queryString}` : ""}${hash}`;
  window.history.replaceState({}, "", url);
}
